﻿require("../controllers/customers");
require("../controllers/tabs");
myApp.controller("homeCtrl", ['$scope', '$http', function ($scope, $http) {
    $scope.setPageClass("yit-home-page");
    $scope.AllStrings = {
        title: " ",
        our_story: {
            h2: " ",
            p: "",
            btn: ""
        }
        , projects: {
            btn: "",
            h2: "",
            calcalist: "",
            yedioth: ""
        },
        customers: {
            btn: "",
            h2:""
        },
        cms: {
            btn: "",
            desc:""
        }
    }
    $scope.redblocks = require("../controllers/comp/redblocks")

    $scope.WaitForStrings(function () {
        var xml = this.strings;
        var home = $(xml).find("home");

        $scope.AllStrings.title = $(home).find("title").find($scope.lang).text().trim();
        //our story
        $scope.AllStrings.our_story.h2 = $(home).find("story").find("h2").find($scope.lang).text().trim();
        $scope.AllStrings.our_story.p = $(home).find("story").find("p").find($scope.lang).text().trim();
        $scope.AllStrings.our_story.btn = $(home).find("story").find("btn").find($scope.lang).text().trim();

        //latest Projects
        $scope.AllStrings.projects.h2 = $(home).find("projects").find("h2").find($scope.lang).text().trim();
        $scope.AllStrings.projects.btn = $(home).find("projects").find("btn").find($scope.lang).text().trim();
        $scope.AllStrings.projects.calcalist = $(home).find("projects").find("calcalist").find($scope.lang).text().trim();
        $scope.AllStrings.projects.yedioth = $(home).find("projects").find("yedioth").find($scope.lang).text().trim();
        $scope.AllStrings.projects.chnSeven = $(home).find("projects").find("chnSeven").find($scope.lang).text().trim();
        
        //customers 
        $scope.AllStrings.customers.h2 = $(home).find("customers").find("h2").find($scope.lang).text().trim();
        $scope.AllStrings.customers.btn = $(home).find("customers").find("btn").find($scope.lang).text().trim();
        $scope.AllStrings.cms.btn = $(home).find("cms").find("btn").find($scope.lang).text().trim();
        $scope.AllStrings.cms.desc = $(home).find("cms").find("desc").find($scope.lang).text().trim();

        $scope.setTitle($scope.AllStrings.title);//set title to the page
        $("h1").html($(home).find("h1").find($scope.lang).html());//h1


    }.bind($scope));
}]);








//////////////////
// WEBPACK FOOTER
// ../scripts/yit/pages/home.js
// module id = 22
// module chunks = 0